import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import { Set_WmsInnModelCheckbox } from "../SliceGRNNormal";
import { fKeyTabInput } from "../../../Utility/Utilitys";
import MoreHorizOutlinedIcon from "@mui/icons-material/MoreHorizOutlined";
import {
  CmpTypographyField,
  CmpCheckboxField,
  CmpButtonKWithIcon,
} from "../../../Component/Common/ToolBox/ToolBox";
import Grid from "@mui/material/Grid";
import { KernCAConfig } from "../../../Redux/roStore";
import GCTitleSticky from "../../../Component/Common/ReuseableComponent/GCTitleSticky";
import {
  CmpDatePickerField001V1,
  CmpSelectArrFieldV1,
  CmpSelectFieldV1,
  CmpTextFieldV1,
} from "../../../Component/Common/ToolBox/ToolBoxV1";
import GCToggleSearchV1 from "../../../Component/Common/ReuseableComponent/GCToggleSearchV1";
import VisibilityIcon from "@mui/icons-material/Visibility";
export default function GCContent({
  sRSP_MRP_Obj,
  fonChangeInputLDiscAmt,
  fGrossAmt,

  xFocusInput,
  xBufferObj,
  fModalPoType,
  fModalPoNo,
  setBufferObj,
  sUnit,
  sFocFlagArr,
  sTypeArr,
  vRdxGRNtax1,
  vRdxGRNtax2,
  fUnit,
  fUnitRate,
  fLDiscPer,
  fFoc,
  fFocFlag,
  fExcise,
  fNetExcise,
  fTaxGroup,
  fCessGroup,
  fType,
  fUnitRateSave_onKeyUp,
  fNarration,
  fNetAmt,
  fDiscPer,
  fDiscAmt,
  fReduceCost,
  fCheckbox,
  fExpDate,
  fItemName,
  fOpenContentItemSearchModalKey,
  fQty,
  fQtyEnter,
  //toggle
  xMediaQuery,
  xonClickbtn,
  xrows,
  xcolumns,
  xRowCellClick,
  xRowClick,
  xToggle,
  xData,
  xOnChangeDropdownInput,
  xDropdownObj,
  xOnKeyUpDropdownInput,
  xErrorMsgDetail,
  xContent_Focus,
  xContent_Blur,
  xTransItemStockShow,
}) {
  const { DBKernObj } = KernCAConfig();

  // let IncentiveGroupShow = true;

  const dispatch = useDispatch();
  const vRdxCheckbox = useSelector(
    (state) => state.SliceGRNNormal.value.GRNNormalCheckbox
  );
  const vModelCheckboxArr = [
    { name: "SplDisc", rdxName: vRdxCheckbox.SplDisc },
    { name: "TDiscPercent", rdxName: vRdxCheckbox.TDiscPercent },
    { name: "TDiscAmt", rdxName: vRdxCheckbox.TDiscAmt },
    { name: "LDiscPercent", rdxName: vRdxCheckbox.LDiscPercent },
    { name: "LDiscAmt", rdxName: vRdxCheckbox.LDiscAmt },
    { name: "FOC", rdxName: vRdxCheckbox.FOC },
    { name: "Excise", rdxName: vRdxCheckbox.Excise },
    { name: "Tax", rdxName: vRdxCheckbox.Tax },
    { name: "Rebate", rdxName: vRdxCheckbox.Rebate },
    { name: "Cess", rdxName: vRdxCheckbox.Cess },
    { name: "UnitRate", rdxName: vRdxCheckbox.UnitRate },
    { name: "GrossAmt", rdxName: vRdxCheckbox.GrossAmt },
    { name: "Taxable", rdxName: vRdxCheckbox.Taxable },
    // { name: "Total", rdxName: vRdxCheckbox.Total },
    { name: "RefNo", rdxName: vRdxCheckbox.RefNo },
    { name: "PO", rdxName: vRdxCheckbox.PO },
    { name: "ItemCd", rdxName: vRdxCheckbox.ItemCd },
    { name: "HcPr", rdxName: vRdxCheckbox.HcPr },
    { name: "ExpDate", rdxName: vRdxCheckbox.ExpDate },
    { name: "PackQty", rdxName: vRdxCheckbox.PackQty },
  ];
  const [sIsChecked, setIsChecked] = useState(false);
  const [sGrnCheckBox, setGrnCheckbox] = useState(vRdxCheckbox);
  const [sOpenContentModal, setOpenContentModal] = useState(false);
  const fModalContentOpen = () => {
    setOpenContentModal(true);
  };

  const fModalContentClose = () => {
    setOpenContentModal(false);
  };
  const fSetCheckBox = (e) => {
    const nameValue = e.target.name;
    const iSCheck = e.target.checked;
    setGrnCheckbox((values) => ({ ...values, [nameValue]: iSCheck }));
  };
  const fIsAllChecked = (e) => {
    const iSCheck = e.target.checked;
    setIsChecked(iSCheck);
    const updatedObj = Object.keys(vRdxCheckbox).reduce((acc, key) => {
      acc[key] = iSCheck;
      return acc;
    }, {});

    // Update the state with the new object
    setGrnCheckbox(updatedObj);
  };
  useEffect(() => {
    dispatch(Set_WmsInnModelCheckbox(sGrnCheckBox));
    const vIsAllTrue = Object.values(sGrnCheckBox).every(
      (value) => value === true
    );
    setIsChecked(vIsAllTrue);
  }, [sGrnCheckBox, dispatch]);
  return (
    <form className="Wms-inbound-grn-content" id="GRNNormalContent">
      <Grid
        container
        spacing={1.3}
        columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
        marginTop={{ xs: 1, sm: 0, md: 0, lg: 0 }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          container
          textAlign={"end"}
          justifyContent={"end"}
        >
          {!xMediaQuery && (
            <Grid item xs={3} sm={3} md={3}>
              <MoreHorizOutlinedIcon
                onClick={fModalContentOpen}
                className="form-label gnr-title-txt"
              />
            </Grid>
          )}
        </Grid>

        <Grid
          item
          xs={12}
          sm={3}
          md={2}
          className={vRdxCheckbox.PO ? "lastkeyDetect" : "hide-content"}
        >
          <GCToggleSearchV1
            xLabelText="PO Type"
            xtabIndex={"101"}
            xName={"B_RefDocTypName"}
            xType={"text"}
            xValue={xBufferObj?.B_RefDocTypName}
            xReadOnly={false}
            xOnChange={(e) => {
              setBufferObj((obj) => ({
                ...obj,
                B_RefDocTyp: "",
                B_RefDocTypName: e.target.value,
              }));
            }}
            xOnKeyUp={fModalPoType}
            xonClickbtn={fModalPoType}
            xError={false}
            xErrorMessage={""}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={7}
          md={2}
          className={vRdxCheckbox.PO ? "lastkeyDetect" : "hide-content"}
        >
          <GCToggleSearchV1
            xLabelText="PO No"
            xtabIndex={"101"}
            xName={"B_RefDocNo"}
            xType={"text"}
            xValue={xBufferObj?.B_RefDocNo}
            xReadOnly={false}
            xOnChange={(e) => {
              setBufferObj((obj) => ({
                ...obj,
                B_RefDocNo: e.target.value,
              }));
            }}
            xOnKeyUp={fModalPoNo}
            xonClickbtn={fModalPoNo}
            xError={false}
            xErrorMessage={""}
          />
        </Grid>

        <Grid
          item
          xs={12}
          sm={2}
          md={2}
          lg={1}
          className={vRdxCheckbox.ItemCd ? "lastkeyDetect" : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="Item Code"
            xSize="small"
            xValue={xBufferObj.B_Itmcd}
            xType={"text"} // text/number/password
            xName={"B_Itmcd"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_Itmcd === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_Itmcd}
          />
        </Grid>

        <Grid
          item
          xs={12}
          sm={8}
          md={xToggle ? 5 : 3}
          // md={"auto"}
          // lg={"auto"}
          className="lastkeyDetect dropDowntoggle"
        >
          <GCToggleSearchV1
            xLabelText="Item Name"
            xtabIndex={"101"}
            xName={"B_ItmName"}
            xType={"text"}
            xValue={xBufferObj?.B_ItmName}
            xReadOnly={false}
            xOnChange={fItemName}
            xOnKeyUp={fOpenContentItemSearchModalKey}
            xError={xErrorMsgDetail.B_ItmName === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_ItmName}
            xMediaQuery={xMediaQuery}
            xonClickbtn={xonClickbtn}
            xrows={xrows}
            xcolumns={xcolumns} //head
            xRowCellClick={xRowCellClick}
            xRowClick={xRowClick}
            xToggle={xToggle}
            xData={xData}
            xOnChangeDropdownInput={xOnChangeDropdownInput}
            xDropdownObj={xDropdownObj}
            xOnKeyUpDropdownInput={xOnKeyUpDropdownInput}
          />
        </Grid>
        <Grid item xs={4} sm={2} md={1} lg={1} className="lastkeyDetect">
          <CmpTextFieldV1
            xLabelText="Qty"
            xSize="small"
            xtabIndex={"102"}
            xValue={xBufferObj.B_Qty}
            xType={"number"} // text/number/password
            xName={"B_Qty"}
            xReadOnly={false}
            xOnChange={fQty}
            xError={xErrorMsgDetail.B_Qty === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_Qty}
            xOnKeyUp={(e) => {
              // fKeyTabInput(e, "B_Unit");
              fQtyEnter(e);
            }}
            xonFocus={xContent_Focus}
            xonBlur={xContent_Blur}
          />
        </Grid>

        <Grid item xs={4} sm={2} md={1} className="lastkeyDetect">
          <CmpSelectFieldV1
            xSize="small"
            xtabIndex={"103"}
            xLabelText="Unit"
            xValue={xBufferObj.B_Unit}
            xOnChange={fUnit}
            xName={"B_Unit"}
            xData={sUnit}
            xValueMember={""}
            xDispalyMember={""}
            xError={xErrorMsgDetail.B_Unit === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_Unit}
            xDisable={false}
          />
        </Grid>

        {vRdxCheckbox.PackQty && (
          <Grid item xs={4} sm={2} md={1} className={"lastkeyDetect"}>
            <CmpTextFieldV1
              xLabelText="PackQty"
              xSize="small"
              xtabIndex={"103"}
              xValue={xBufferObj.B_PackQty}
              xType={"text"} // text/number/password
              xName={"B_PackQty"}
              xReadOnly={true}
              xOnChange={() => {}}
              xError={false}
              xErrorMessage={""}
            />
          </Grid>
        )}
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          className={vRdxCheckbox.SplDisc ? "lastkeyDetect" : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="Spl.Disc"
            xSize="small"
            xValue={xBufferObj.SplDisc}
            xType={"text"} // text/number/password
            xName={"SplDisc"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.SplDisc === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.SplDisc}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.UnitRate ? "lastkeyDetect" : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="Unit Rate"
            xSize="small"
            xtabIndex={"104"}
            xValue={xBufferObj.B_URateFc}
            xType={"number"} // text/number/password
            xName={"B_URateFc"}
            xReadOnly={false}
            xOnChange={fUnitRate}
            xError={xErrorMsgDetail.B_URateFc === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_URateFc}
            xonFocus={xContent_Focus}
            xonBlur={xContent_Blur}
            xOnKeyUp={(e) => fUnitRateSave_onKeyUp(e)}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.GrossAmt ? "lastkeyDetect" : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="Gross Amt"
            xSize="small"
            xtabIndex={"105"}
            xValue={xBufferObj.B_GrossAmt}
            xType={"text"} // text/number/password
            xName={"B_GrossAmt"}
            xReadOnly={false}
            xOnChange={fGrossAmt}
            xError={xErrorMsgDetail.B_GrossAmt === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_GrossAmt}
            xonFocus={xContent_Focus}
            xonBlur={xContent_Blur}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={
            vRdxCheckbox.TDiscPercent ? "lastkeyDetect" : "hide-content"
          }
        >
          <CmpTextFieldV1
            xLabelText="T.Disc %"
            xSize="small"
            xValue={xBufferObj.B_TDiscPerc}
            xType={"text"} // text/number/password
            xName={"B_TDiscPerc"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_TDiscPerc === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_TDiscPerc}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.TDiscAmt ? "" : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="T.Disc Amt"
            xSize="small"
            xValue={xBufferObj.B_TDiscAmt}
            xType={"text"} // text/number/password
            xName={"B_TDiscAmt"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_TDiscAmt === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_TDiscAmt}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={
            vRdxCheckbox.LDiscPercent ? "lastkeyDetect" : "hide-content"
          }
        >
          <CmpTextFieldV1
            xLabelText={"L.Disc %"}
            xSize="small"
            xtabIndex={"106"}
            xValue={xBufferObj.B_LDiscPerc}
            xType={"number"} // text/number/password
            xName={"B_LDiscPerc"}
            xReadOnly={false}
            xOnChange={fLDiscPer}
            xError={xErrorMsgDetail.B_LDiscPerc === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_LDiscPerc}
            xonFocus={xContent_Focus}
            xonBlur={xContent_Blur}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.LDiscAmt ? "lastkeyDetect" : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="L.Disc Amt"
            xSize="small"
            xValue={xBufferObj.B_LDiscAmt}
            xType={"text"} // text/number/password
            xName={"B_LDiscAmt"}
            xReadOnly={false}
            xOnChange={fonChangeInputLDiscAmt}
            xError={xErrorMsgDetail.B_LDiscAmt === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_LDiscAmt}
            // xOnKeyUp={(e) => {
            //   xFocusInput("B_FocAmt");
            // }}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          className={
            vRdxCheckbox.FOC ? "lastkeyDetect text-center " : "hide-content"
          }
          justifyContent={"center"}
        >
          {/* <CmpTypographyField xcomponent={"div"} xText={"FOC"} /> */}
          <CmpCheckboxField
            xtabIndex={"107"}
            xChecked={xBufferObj?.B_FocFlag === "Y"}
            xOnChange={fFoc}
            xDisabled={false}
            xName={"B_FocFlag"}
            xNameField={"FOC"}
            xError={xErrorMsgDetail.B_FocFlag === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_FocFlag}
            xlabelPlacement="end"
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.FOC ? "lastkeyDetect" : "hide-content"}
        >
          {/* <CmpTypographyField xcomponent={"div"} xText={"FOC Flag"} /> */}
          <CmpSelectArrFieldV1
            xtabIndex={"108"}
            xLabelText="FOC Flag"
            xValue={xBufferObj.B_AprmtFlag}
            xOnChange={fFocFlag}
            xName={"B_AprmtFlag"}
            xData={sFocFlagArr}
            xValueMember={""}
            xDispalyMember={""}
            xError={xErrorMsgDetail.B_AprmtFlag === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_AprmtFlag}
            xDisable={false}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.FOC ? "lastkeyDetect" : "hide-content"}
        >
          {/* <CmpTypographyField xcomponent={"div"} xText={"FOC Amount"} /> */}
          <CmpTextFieldV1
            xLabelText="FOC Amount"
            xSize="small"
            xValue={xBufferObj.B_FocAmt}
            xType={"text"} // text/number/password
            xName={"B_FocAmt"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_FocAmt === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_FocAmt}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.Excise ? "lastkeyDetect" : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="Excise"
            xSize="small"
            xtabIndex={"109"}
            xValue={xBufferObj.B_ExciseTaxAmt}
            xType={"number"} // text/number/password
            xName={"B_ExciseTaxAmt"}
            xReadOnly={false}
            xOnChange={fExcise}
            xError={xErrorMsgDetail.B_ExciseTaxAmt === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_ExciseTaxAmt}
            xonFocus={xContent_Focus}
            xonBlur={xContent_Blur}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.Excise ? "lastkeyDetect" : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="Net Excise"
            xSize="small"
            xtabIndex={"110"}
            xValue={xBufferObj.B_ExciseTaxNetAmt}
            xType={"number"} // text/number/password
            xName={"B_ExciseTaxNetAmt"}
            xReadOnly={true}
            xOnChange={fNetExcise}
            xError={xErrorMsgDetail.B_ExciseTaxNetAmt === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_ExciseTaxNetAmt}
            xonFocus={xContent_Focus}
            xonBlur={xContent_Blur}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.Taxable ? "lastkeyDetect" : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="Taxable"
            xSize="small"
            xValue={xBufferObj.B_NetAmt}
            xType={"number"} // text/number/password
            xName={"B_NetAmt"}
            xReadOnly={true}
            xOnChange={fNetAmt}
            xError={xErrorMsgDetail.B_NetAmt === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_NetAmt}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.Taxable ? "lastkeyDetect" : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="Net Amt"
            xSize="small"
            xValue={xBufferObj.B_NetAmt}
            xType={"number"} // text/number/password
            xName={"B_NetAmt"}
            xReadOnly={true}
            xOnChange={fNetAmt}
            xError={xErrorMsgDetail.B_NetAmt === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_NetAmt}
            // xOnKeyUp={xKey}
          />
        </Grid>

        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.Tax ? "lastkeyDetect" : "hide-content"}
        >
          <CmpSelectFieldV1
            xSize="small"
            xtabIndex={"111"}
            xLabelText="TaxGroup"
            xValue={xBufferObj.B_TaxDept}
            xOnChange={fTaxGroup}
            xName={"B_TaxDept"}
            xData={vRdxGRNtax1}
            xValueMember={""}
            xDispalyMember={""}
            xError={xErrorMsgDetail.B_TaxDept === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_TaxDept}
            xDisable={false}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.Tax ? "lastkeyDetect" : "hide-content"}
        >
          {/* <CmpTypographyField xcomponent={"div"} xText={"Tax %"} /> */}
          <CmpTextFieldV1
            xLabelText="Tax %"
            xSize="small"
            xValue={xBufferObj.B_TaxPerc}
            xType={"text"} // text/number/password
            xName={"B_TaxPerc"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_TaxPerc === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_TaxPerc}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.Tax ? "lastkeyDetect" : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="Tax Amt"
            xSize="small"
            xValue={xBufferObj.B_TaxAmt}
            xType={"text"} // text/number/password
            xName={"B_TaxAmt"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_TaxAmt === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_TaxAmt}
            // xOnKeyUp={(e) => {
            //   xFocusInput("B_TaxPerc2");
            // }}
          />
        </Grid>

        <Grid
          item
          xs={4}
          sm={2}
          md={0.5}
          className={vRdxCheckbox.HcPr ? "lastkeyDetect" : "hide-content"}
        >
          <CmpCheckboxField
            xtabIndex={"114"}
            xChecked={xBufferObj?.HC === "Y"}
            xOnChange={fCheckbox}
            xDisabled={false}
            xName={"HC"}
            xNameField={"HC"}
            xError={xErrorMsgDetail.HC === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.HC}
            xlabelPlacement="end"
          />
        </Grid>

        <Grid
          item
          xs={4}
          sm={2}
          md={0.5}
          className={vRdxCheckbox.HcPr ? "lastkeyDetect" : "hide-content"}
        >
          <CmpCheckboxField
            xtabIndex={"114"}
            xChecked={xBufferObj?.PR === "Y"}
            xOnChange={fCheckbox}
            xDisabled={false}
            xName={"PR"}
            xNameField={"PR"}
            xError={xErrorMsgDetail.PR === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.PR}
            xlabelPlacement="end"
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={2}
          className={vRdxCheckbox.ExpDate ? "lastkeyDetect" : "hide-content"}
        >
          <CmpDatePickerField001V1
            xtabIndex={"115"}
            xLabelText="ExpDate"
            xValue={xBufferObj.ExpDate}
            xOnChange={fExpDate}
            xName={"ExpDate"}
            xError={xErrorMsgDetail.ExpDate === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.ExpDate}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.Cess ? "lastkeyDetect" : "hide-content"}
        >
          <CmpSelectFieldV1
            xSize="small"
            xtabIndex={"112"}
            xLabelText="Cess Group"
            xValue={xBufferObj.B_TaxDept2}
            xOnChange={fCessGroup}
            xName={"B_TaxDept2"}
            xData={vRdxGRNtax2}
            xValueMember={""}
            xDispalyMember={""}
            xError={xErrorMsgDetail.B_TaxDept2 === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_TaxDept2}
            xDisable={false}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.Cess ? "lastkeyDetect" : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="Cess %"
            xSize="small"
            xValue={xBufferObj.B_TaxPerc2}
            xType={"text"} // text/number/password
            xName={"B_TaxPerc2"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_TaxPerc2 === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_TaxPerc2}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.Cess ? "lastkeyDetect" : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="Cess Amt"
            xSize="small"
            xValue={xBufferObj.B_TaxAmt2}
            xType={"text"} // text/number/password
            xName={"B_TaxAmt2"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_TaxAmt2 === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_TaxAmt2}
            // xOnKeyUp={xKey}
          />
        </Grid>

        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.Cess ? "lastkeyDetect" : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="Add Cess Amt"
            xSize="small"
            xValue={xBufferObj.B_Ad_PCRate}
            xType={"text"} // text/number/password
            xName={"B_Ad_PCRate"}
            xReadOnly={true}
            xOnChange={""}
            xError={false}
            xErrorMessage={""}
            // xOnKeyUp={(e) => {
            //   xFocusInput("SplDiscPerc");
            // }}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.Cess ? "lastkeyDetect" : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="Amt"
            xSize="small"
            xValue={xBufferObj.B_NetAddCess}
            xType={"text"} // text/number/password
            xName={"B_NetAddCess"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_NetAddCess === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_NetAddCess}
            // xOnKeyUp={(e) => {
            //   xFocusInput("SplDiscPerc");
            // }}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.Rebate ? "lastkeyDetect" : "hide-content"}
        >
          <CmpSelectFieldV1
            xSize="small"
            xtabIndex={"113"}
            xLabelText="Type"
            xValue={xBufferObj.RebateType}
            xOnChange={fType}
            xName={"RebateType"}
            xData={sTypeArr}
            xValueMember={""}
            xDispalyMember={""}
            xError={xErrorMsgDetail.RebateType === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.RebateType}
            xDisable={
              DBKernObj?.COUNTRY?.Val?.toUpperCase() == "KSA" ? true : false
            }
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={
            vRdxCheckbox.Rebate ? "lastkeyDetect text-center" : "hide-content"
          }
        >
          <CmpCheckboxField
            xtabIndex={"114"}
            xChecked={xBufferObj?.ReduceCost === "Y"}
            xOnChange={fReduceCost}
            xDisabled={
              xBufferObj.RebateType == "" ||
              xBufferObj.RebateType == "Credit Note"
                ? true
                : false
            }
            xName={"ReduceCost"}
            xNameField={"(-) Cost"}
            xError={xErrorMsgDetail.ReduceCost === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.ReduceCost}
            xlabelPlacement="end"
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.Rebate ? "lastkeyDetect" : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="Disc%"
            xSize="small"
            xtabIndex={"115"}
            xValue={xBufferObj.SplDiscPerc}
            xType={"number"} // text/number/password
            xName={"SplDiscPerc"}
            // xReadOnly={xBufferObj.RebateType == "" ? true : false}
            xReadOnly={xBufferObj.RebateType == "" ? true : false}
            xOnChange={fDiscPer}
            xError={xErrorMsgDetail.SplDiscPerc === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.SplDiscPerc}
            xonFocus={xBufferObj.RebateType == "" ? "" : xContent_Focus}
            xonBlur={xBufferObj.RebateType == "" ? "" : xContent_Blur}
            // xOnKeyUp={xKey}
          />
        </Grid>
        <Grid
          item
          xs={4}
          sm={2}
          md={1}
          lg={1}
          className={vRdxCheckbox.Rebate ? "lastkeyDetect" : "hide-content"}
        >
          <CmpTextFieldV1
            xLabelText="Disc Amt"
            xSize="small"
            xtabIndex={"116"}
            xValue={xBufferObj.SplDiscAmt}
            xType={"number"} // text/number/password
            xName={"SplDiscAmt"}
            xReadOnly={xBufferObj.RebateType == "" ? true : false}
            xOnChange={fDiscAmt}
            xError={xErrorMsgDetail.SplDiscAmt === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.SplDiscAmt}
            xonFocus={xBufferObj.RebateType == "" ? "" : xContent_Focus}
            xonBlur={xBufferObj.RebateType == "" ? "" : xContent_Blur}
            // xOnKeyUp={xKey}
          />
        </Grid>
        {xMediaQuery && (
          <Grid
            item
            xs={4}
            sm={2}
            md={0.5}
            className="lastkeyDetect"
            display={"flex  "}
            alignItems={"center"}
            justifyContent={"space-around"}
          >
            <div>
              <CmpButtonKWithIcon
                xOnClick={(e) => {
                  fModalContentOpen(e, "checkboxModal");
                }}
                xDisabled={false}
                xIcon={<VisibilityIcon fontSize={"small"} />}
                xcolor="primary"
              />
            </div>
          </Grid>
        )}

        {!xMediaQuery && xTransItemStockShow && (
          <>
            <Grid
              item
              xs={"auto"}
              sm={"auto"}
              md={"auto"}
              className={"lastkeyDetect"}
            >
              <CmpTypographyField
                xcomponent={"span"}
                xText={"MRP=" + sRSP_MRP_Obj.MRP || 0}
              />
            </Grid>

            <Grid
              item
              xs={"auto"}
              sm={"auto"}
              md={"auto"}
              className="lastkeyDetect"
            >
              <CmpTypographyField
                xcomponent={"span"}
                xText={"RSP=" + sRSP_MRP_Obj?.RSP || 0}
              />
            </Grid>
          </>
        )}
      </Grid>

      <Modal
        open={sOpenContentModal}
        onClose={fModalContentClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-content-checkbox">
          <GCTitleSticky title={"Detail list"} onClose={fModalContentClose} />

          <div className="container-fluid">
            <div className="wms-label">
              <div className="checkbox-mb">
                <label className="form-label ">
                  <input
                    className="form-check-input "
                    type="checkbox"
                    name="AllChecked"
                    checked={sIsChecked}
                    onChange={(e) => {
                      fIsAllChecked(e);
                    }}
                  />{" "}
                  All
                </label>
              </div>
              <>
                {vModelCheckboxArr?.map((obj, index) => (
                  <div className="checkbox-mb" key={"Wmscheckbox" + index}>
                    <label className="form-label">
                      <input
                        className="form-check-input "
                        type="checkbox"
                        name={obj.name}
                        checked={obj.rdxName}
                        onChange={(e) => {
                          fSetCheckBox(e);
                        }}
                      />{" "}
                      {obj.name}
                    </label>
                  </div>
                ))}
              </>
            </div>
          </div>
        </Box>
      </Modal>
    </form>
  );
}
